import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Annotation} from '../models/annotatios';
import {map} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnnotationService {

  constructor (private db: AngularFirestore) { }

  select () {
    return this.db.collection<any>('sbccv_annotations', ref => ref
      .orderBy('date', 'asc')).snapshotChanges();
  }

  load () {
    return this.db.collection<any>('sbccv_annotations', ref => ref
      .orderBy('date', 'asc')).get();
  }

  loadByName () {
    return this.db.collection<any>('sbccv_annotations', ref => ref
      .orderBy('member_name', 'asc')
      .orderBy('date', 'asc')).get();
  }

  selectByMemberId (memberId: string) {
    return this.db.collection<Annotation>('sbccv_annotations', ref => ref
      .where("member_id", "==", memberId)
      .orderBy('date', 'asc'))
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          return {
            ...data,
            id,
            // Tratamento seguro de datas
            date: data.date?.toDate() || null
          } as Annotation;
        }))
      );
  }

  selectPending () {
    return this.db.collection<Annotation>('sbccv_annotations', ref => ref
      .where("status", "==", 1)
      .orderBy('date', 'asc')).snapshotChanges();
  }

  insert (entity: Annotation) {
    return this.db.collection('sbccv_annotations').add(Object.assign({}, entity));
  }

  update (entity: any) {
    return this.db.collection('sbccv_annotations')
      .doc(entity.id)
      .set(Object.assign({}, entity), {'merge': true});
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_annotations').doc(entity_id).delete();
  }

  createAnnotation (data) {
    const annotation = new Annotation()
    annotation.id = data.id;
    annotation.member_id = data.member_id;
    annotation.member_name = data.member_name;
    annotation.date = data.date;
    annotation.status = data.status ? data.status : 0;
    annotation.text = data.text;
    return annotation
  }

}


